import { StrictDict } from '../../utils';

const LicenseTypes = StrictDict({
  creativeCommons: 'creative-commons',
  allRightsReserved: 'all-rights-reserved',
  publicDomainDedication: 'public-domain-dedication',
});

export default LicenseTypes;
